import * as React from 'react';
import { compose } from 'recompose';
import { createStyles } from '@material-ui/styles';
import { withBaseProps } from '../Utils';
import { Text } from './';
const styles = (theme) => createStyles({
    root: {},
    autoWidth: {
        maxWidth: 0,
        minWidth: '100%',
        display: 'block',
        lineHeight: 1.5,
    },
});
const DetailText = ({ classes, theme, children, label }) => {
    return (React.createElement("div", { className: classes.root },
        React.createElement(Text, { size: "mediumSmall", color: theme.color.grey.default, block: true }, label),
        typeof children === 'string' ? (React.createElement(Text, { className: classes.autoWidth, ellipsis: true }, children)) : (children)));
};
export default compose(withBaseProps({ styles }))(DetailText);
//# sourceMappingURL=DetailText.js.map